import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { AddressCoordinates } from './address-coordinates.model';

export const ADDRESS_POSITION_SCHEMA = Object.freeze({
  COORDINATES: AddressCoordinates,
  // other fields that we don't care about
});
const RECORD = generateSchema(ADDRESS_POSITION_SCHEMA);
const KEYS: any = generateKeys(ADDRESS_POSITION_SCHEMA);

export class AddressPosition extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.COORDINATES,
        value: props.get(KEYS.COORDINATES)
          ? new AddressCoordinates(this.coordinates)
          : null,
      },
    ]);

    return selfModel as AddressPosition;
  }

  get coordinates(): AddressCoordinates {
    return this.get(KEYS.COORDINATES);
  }
}
